<template>
  <div class="personal-info-page-template">
    <div class="profile-image-wrapper">
      <h5>Profile Info</h5>
      <div class="profile-image">
        <!-- <Icon @click="nextAvatar()" type="arrow-left-b" /> -->
        <img :src="onboardInfo.avatar" />
        <!-- <Icon @click="previousAvatar()" type="arrow-right-b" /> -->
      </div>
    </div>
    <div>
      <div style="margin-left: 20px;" class="input-wrapper">
        <div class="required-dot" />
        <span>Required fields</span>
      </div>
      <div class="input-wrapper" v-if="shouldValidate('generic_id')">
        <div :class="shouldValidate('generic_id') ? 'required-dot' : 'non-required-dot'" />
        <Input
          size="large"
          :disabled="isSaving"
          v-model="onboardInfo.generic_id"
          :placeholder="`Enter your ${genericIdLabel}`"
        />
      </div>
      <div class="input-wrapper">
        <div :class="shouldValidate('display_name') ? 'required-dot' : 'non-required-dot'" />
        <Input
          size="large"
          :disabled="isSaving"
          v-model="onboardInfo.display_name"
          placeholder="Enter your display/nickname"
        />
      </div>
      <div class="input-wrapper">
        <div :class="shouldValidate('first_name') ? 'required-dot' : 'non-required-dot'" />
        <Input
          size="large"
          :disabled="isSaving"
          v-model="onboardInfo.first_name"
          placeholder="Enter full name"
        />
      </div>
      <div class="input-wrapper">
        <div :class="shouldValidate('email') ? 'required-dot' : 'non-required-dot'" />
        <Input
          size="large"
          type="email"
          :disabled="isSaving"
          v-model="onboardInfo.email"
          placeholder="Enter your email"
        />
      </div>
      <div class="input-wrapper">
        <div :class="shouldValidate('mobile') ? 'required-dot' : 'non-required-dot'" />
        <tel-input-lg
          :disabled="isSaving"
          placeholder="Enter your mobile number"
          v-model="onboardInfo.contact_number"
          ref="telInput"
        ></tel-input-lg>
      </div>
      <div style="justify-content: space-between; padding: 20px 0 20px 20px;" class="input-wrapper">
        <p>Keep my profile private</p>
        <i-switch :disabled="isSaving" v-model="isProfilePrivate" style="float:right" />
      </div>
      <div class="input-wrapper">
        <Button
          @click="save"
          :disabled="isSaving"
          :loading="isSaving"
          long
          size="large"
          type="primary"
        >Submit</Button>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 26px;">
        <a @click="logout">Login</a>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/utils.js";
import { TelInputLg } from "@/helpers/tel-input";
import { mapGetters, mapActions } from "vuex";
import { Message } from "iview";
import VueCookie from "vue-cookie";
import _ from "lodash";

export default {
  name: "PersonalInfoPage",
  data() {
    return {
      onboardInfo: {
        id: "",
        display_name: "",
        first_name: "",
        email: "",
        contact_number: "",
        is_public: 0,
        avatar: "",
        generic_id: ""
      },
      isSaving: false
    };
  },
  components: {
    TelInputLg
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    isProfilePrivate: {
      get() {
        return this.onboardInfo.is_public == 0 ? true : false;
      },
      set(v) {
        this.onboardInfo.is_public = !v;
      }
    },
    baseUrl() {
      return this.$store.state.user.avatars.base_url;
    },
    avatars() {
      return this.$store.state.user.avatars.images || [];
    },
    avatarList() {
      let avatarArray = [];

      Object.keys(this.avatars).forEach(key => {
        this.avatars[key].forEach(avatar => {
          avatarArray.push(this.baseUrl + key + "/" + avatar);
        });
      });

      return avatarArray.slice().reverse();
    },
    genericIdLabel() {
      return _.get(this.brandInfo, "generic_id.label", "ID");
    }
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 200);
  },
  methods: {
    ...mapActions({
      getImageLibraries: "user/getImageLibraries"
    }),
    logout() {
      this.$store.dispatch("base/signout")
    },
    setIsVerificationSent(payload) {
      VueCookie.set(Cons[0].PATHS.NAME + "VERIFICATION_SENT", payload);
    },
    getNextAvatar() {
      let currentAvatarIndex = this.avatarList.indexOf(this.onboardInfo.avatar);

      if (currentAvatarIndex == -1) return this.getRandomAvatar();
      else
        return this.avatarList.length > currentAvatarIndex + 1
          ? this.avatarList[currentAvatarIndex + 1]
          : this.avatarList[0];
    },
    getPreviousAvatar() {
      let currentAvatarIndex = this.avatarList.indexOf(this.onboardInfo.avatar);

      if (currentAvatarIndex == -1) return this.getRandomAvatar();
      else
        return currentAvatarIndex > 0
          ? this.avatarList[currentAvatarIndex - 1]
          : this.avatarList[0];
    },
    nextAvatar() {
      this.onboardInfo.avatar = this.getNextAvatar();
    },
    previousAvatar() {
      this.onboardInfo.avatar = this.getPreviousAvatar();
    },
    shouldValidate(key) {
      return this.brandInfo.required_fields
        ? this.brandInfo.required_fields.includes(key)
        : false;
    },
    validate() {
      if (this.shouldValidate("email") && !this.onboardInfo.email) {
        this.showMessage("Email is required");
        return false;
      }
      if (
        this.shouldValidate("email") &&
        this.onboardInfo.email &&
        !this.validateEmail(this.onboardInfo.email)
      ) {
        this.showMessage("Invalid email format");
        return false;
      }
      if (this.shouldValidate("mobile") && !this.onboardInfo.contact_number) {
        this.showMessage("Mobile number is required");
        return false;
      }

      if (this.shouldValidate("mobile") && !this.isValidNumber()) {
        this.showMessage("Invalid mobile number format");
        return false;
      }

      if (this.shouldValidate("generic_id") && !this.onboardInfo.generic_id) {
        this.showMessage(`${this.genericIdLabel} is required`);
        return false;
      }

      if (
        this.shouldValidate("display_name") &&
        !this.onboardInfo.display_name
      ) {
        this.showMessage("Display name is required");
        return false;
      }

      if (this.shouldValidate("first_name") && !this.onboardInfo.first_name) {
        this.showMessage("Full name is required");
        return false;
      }

      return true;
    },
    isValidNumber() {
      return this.$refs.telInput.state;
    },
    showMessage(content) {
      Message.warning(content);
    },
    async save() {
      if (!this.validate()) return;
      try {
        this.isSaving = true;
        await this.$store.dispatch("user/saveOnboardingData", {
          data: this.onboardInfo,
          newAvatar: this.onboardInfo.avatar
        });
        this.setIsVerificationSent(
          JSON.stringify({
            email: this.onboardInfo.email,
            mobile: this.onboardInfo.contact_number
          })
        );
        this.nextPage();
      } catch (error) {
        if (error.response.data.error.message == "Mobile already in use!") {
          Message.warning({
            render: h => {
              return h("div", [
                "Mobile in use, ",
                h(
                  "a",
                  {
                    on: {
                      click: () => {
                        this.logout()
                      }
                    }
                  },
                  "login"
                ),
                " instead"
              ]);
            },
            duration: 6
          });
        }
      } finally {
        this.isSaving = false;
      }
    },
    async init() {
      await this.getImageLibraries();
      this.onboardInfo.generic_id = this.userInfo.generic_id;
      this.onboardInfo.id = this.userInfo.id;
      this.onboardInfo.avatar = this.userInfo.avatar
        ? this.userInfo.avatar.indexOf("mystery-man") > -1
          ? this.getRandomAvatar()
          : this.userInfo.avatar
        : this.getRandomAvatar();

      if (
        this.userInfo.display_name == "No Displayname" ||
        this.userInfo.display_name == this.userInfo.user_login
      ) {
        this.onboardInfo.display_name = "";
      } else {
        this.onboardInfo.display_name = this.userInfo.display_name;
      }

      this.onboardInfo.first_name = this.userInfo.first_name;

      //has precription ???
      let prescriptionContact = VueCookie.get("PRESCRIPTION_MOBILE");
      let isEmail = prescriptionContact
        ? prescriptionContact.includes("@")
        : false;

      let firstUnverifiedEmail = _.filter(this.userInfo.email, email => {
        return email.validated_at == null;
      });

      let userInfoEmail =
        firstUnverifiedEmail.length > 0
          ? firstUnverifiedEmail[0].email
          : this.userInfo.email && this.userInfo.email.length > 0
          ? this.userInfo.email[0].email
          : "";

      this.onboardInfo.email = prescriptionContact
        ? isEmail
          ? prescriptionContact
          : userInfoEmail
        : userInfoEmail;

      this.onboardInfo.contact_number = prescriptionContact
        ? !isEmail
          ? prescriptionContact
          : this.userInfo.contact_number
        : this.userInfo.contact_number;

      this.$refs.telInput.mobile_number = this.onboardInfo.contact_number;
      this.onboardInfo.is_public = this.userInfo.is_public == 0 ? true : false;
    },
    getRandomAvatar() {
      return this.avatarList[
        Math.floor(Math.random() * Math.floor(this.avatarList.length))
      ];
    },
    validateEmail(email) {
      return Utils.validateEmail(email);
    },
    nextPage() {
      this.$emit("nextPage", {
        email: this.onboardInfo.email,
        mobile: this.onboardInfo.contact_number
      });
    }
  }
};
</script>

<style lang="scss">
.input-wrapper {
  .tel-input-template {
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.personal-info-page-template {
  height: 100%;
}
.non-required-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #ddd;
  margin-right: 10px;
}
.required-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: var(--primary-color);
  margin-right: 10px;
}
.profile-image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background: #acacac;
    margin: 10px;
    border: 5px #dcdcdc solid;
  }
}
.profile-image {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>